import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

export const useImpactChartType = createGlobalState({
  storage: "session",
  key: "diagnosisChartType",
  type: io.string,
  scoped: true,
});
